import { Box } from '@material-ui/core';
import { Accordion } from '@components';
import { content } from '@content';
import { AddSignalDropdown } from './AddSignalDropdown';
import { useStyles } from './PersonalizationPanel.styles';
import { PersonalizationPanelProps } from './PersonalizationPanel.props';
import { useState } from 'react';

export const PersonalizationPanel = ({ className, leftPosition, width }: PersonalizationPanelProps): JSX.Element => {
  const styles = useStyles();

  const [personalizationExpanded, setPersonalizationExpanded] = useState(true);

  return (
    <Box className={`${styles.personalizationPanel} ${className}`} style={{ left: leftPosition, width: width }}>
      <Accordion
        expanded={personalizationExpanded}
        onChange={() => {
          setPersonalizationExpanded(!personalizationExpanded);
        }}
        title={content.personalization}
        uiType="quaternary"
      >
        <AddSignalDropdown />
      </Accordion>
    </Box>
  );
};

PersonalizationPanel.displayName = 'PersonalizationPanel';
